import "../../../styles/verifications/verification.css";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "react-phone-number-input/style.css";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import { countrycodes } from "../../../components/input/InputPhoneTel";
import { smsVerificationUrl } from "../../../api/endpoints";
import { verifyUserUrl } from "../../../api/endpoints";
import { useNavigate } from "react-router-dom";
import { setUser } from "../../../slice/webStoreUserSlice";

import { IoArrowBackSharp } from "react-icons/io5";
import Spinner from "../../../components/uxCollections/Loaders";
import { uiAlert } from "../../../components/alerts/customAlert/uiAlert";

const VerifyPhoneNumber = () => {
  const [pickedCountryCode, setPickedCountryCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [formatedPhoneNumber, setFormatedPhoneNumber] = useState("");
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [loading, setLoading] = useState(false);
  const { user } = useSelector((state) => state.webStoreUser);

  useEffect(() => {
    let countryCode = countrycodes.find((country) => country.name === user.userCountry).code;
    setPickedCountryCode(countryCode);
  }, []);

  useEffect(() => {
    if (phoneNumber && parsePhoneNumber(phoneNumber) && parsePhoneNumber(phoneNumber).isValid()) {
      setFormatedPhoneNumber(parsePhoneNumber(phoneNumber).number);
      setIsPhoneNumberValid(true);
      console.log(parsePhoneNumber(phoneNumber).number);
    } else {
      setIsPhoneNumberValid(false);
    }
  }, [phoneNumber]);

  const sendOTP = async () => {
    setLoading(true);
    console.log("sending OTP");

    /* send OTP to phone number */

    try {
      let response = await fetch(smsVerificationUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify({ phoneNumber }),
      });
      if (!response.ok) {
        throw new Error("Failed to send verification code");
      }

      if (response.ok) {
        setIsPhoneNumberValid(false);
        setLoading(false);
        const { generatedCode } = await response.json();
        setVerificationCode(generatedCode);
        console.log(generatedCode);
        nextPage();
      }
    } catch (error) {
      console.log(error);
      uiAlert("Failed to send verification code, please try again", "error");
    } finally {
      setLoading(false);
    }
  };
  const nextPage = () => {
    let currentNode = document.querySelector(`.inputPhoneNumerDIv`);
    let nextNode = document.querySelector(`.verifyPhoneNumerDIv`);

    currentNode.style.visibility = "hidden";
    nextNode.style.transform = "translateX(-420px)";

    nextNode.style.visibility = "visible";

    currentNode.style.transform = "translateX(-420px)";
    setLoading(false);
  };

  return (
    <>
      <div className='VerificationWrapper12'>
        <div className='verifcationDIvFlex'>
          <div className='inputPhoneNumerDIv'>
            <h3 className='titleVerfication2'>To complete your registration, please verify your phone number</h3>
            <p>Add your phone number. We will send you a verification token so we confirm your phone number</p>

            <div style={{ width: "100%" }} className=' inputCustdet12 inputPhoneNumber'>
              <PhoneInput value={phoneNumber} onChange={setPhoneNumber} defaultCountry={pickedCountryCode} placeholder='91 44 72 64' />
            </div>
            {phoneNumber && !isPhoneNumberValid && (
              <p style={{ marginTop: "-24px" }} className='stockHighlightMesggaes2'>
                Phone number is not valid
              </p>
            )}

            <div className='sendOTPDiv'>
              {isPhoneNumberValid ? (
                loading ? (
                  <button style={{ opacity: "0.7", cursor: "not-allowed" }}>Sending</button>
                ) : (
                  <button onClick={sendOTP}>Send OTP</button>
                )
              ) : (
                <button style={{ opacity: "0.7", cursor: "not-allowed" }}>Send OTP</button>
              )}
            </div>
            <p>
              By providing my phone number, i hereby agree and accept the <a href='#'>Terms of Service</a> and <a href='#'>Privacy Policy</a> in order to use
              the service.
            </p>
          </div>
          <VerifyPhoneDiv2 verificationCode={verificationCode} resendOTP={sendOTP} inputEDNumber={formatedPhoneNumber} />
        </div>
      </div>
    </>
  );
};

export default VerifyPhoneNumber;

const VerifyPhoneDiv2 = ({ verificationCode, resendOTP, inputEDNumber }) => {
  const [phoneNumber, setPhoneNumber] = useState({
    /* code not phone number */ digit1: "",
    digit2: "",
    digit3: "",
    digit4: "",
    digit5: "",
  });
  const [isCodeValid, setIsCodeValid] = useState(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (phoneNumber.digit1 && phoneNumber.digit2 && phoneNumber.digit3 && phoneNumber.digit4 && phoneNumber.digit5) {
      setIsCodeValid(true);
      verifyCode();
    } else {
    }
  }, [phoneNumber]);

  const nextInputSeries = (numberInseries) => {
    /* find input */
    let input = document.querySelector(`input[name=digit${numberInseries}]`);
    /* find next input */
    if (input.value.length === 1 && numberInseries < 5) {
      let nextInput = document.querySelector(`input[name=digit${numberInseries + 1}]`);
      nextInput.focus();
    }
  };

  const verifyCode = async () => {
    console.log("verifying code");
    /* verify code, if code is the same, contack Backend and confirm user. then navigate to home page */
    setIsCodeValid(true);
    let code = `${phoneNumber.digit1}${phoneNumber.digit2}${phoneNumber.digit3}${phoneNumber.digit4}${phoneNumber.digit5}`;
    console.log(code, verificationCode);
    setLoading(true);
    if (code.toString() === verificationCode.toString()) {
      console.log("code is valid");
      /* send success to back end to verify user */

      try {
        let response = await fetch(verifyUserUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          body: JSON.stringify({ isPhoneNumberVerified: "yes", verifiedPhoneNo: inputEDNumber }),
        });

        if (response.ok) {
          console.log("user verified");
          let data = await response.json();
          console.log(data);
          dispatch(setUser(data));
          navigate("/settings/subscription");
          setLoading(false);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      console.log("code is not valid");
      setIsCodeValid(false);
      setLoading(false);
    }
  };
  const changeNumber = () => {
    let prevousNode = document.querySelector(`.inputPhoneNumerDIv`);
    let currentNode = document.querySelector(`.verifyPhoneNumerDIv`);

    currentNode.style.visibility = "hidden";
    prevousNode.style.transform = "translateX(0)";
    prevousNode.style.visibility = "visible";

    currentNode.style.transform = "translateX(0)";
  };
  return (
    <>
      <div className='verifyPhoneNumerDIv'>
        <div onClick={changeNumber} className='backToEditNo'>
          {" "}
          <IoArrowBackSharp />
          <p>Change number</p>
        </div>
        <h3 className='titleVerfication2'>
          Verify your <br></br> Phone number
        </h3>
        <p>
          Enter the 5 digits code <br></br> sent to {inputEDNumber ? inputEDNumber : "your phone number"} here
        </p>
        <div className='InputSeries'>
          <input
            value={phoneNumber.digit1}
            onChange={(e) => {
              setPhoneNumber({ ...phoneNumber, digit1: e.target.value });
              nextInputSeries(1);
            }}
            maxLength={1}
            name='digit1'
            data-next='digit2'
            type='text'
            autoFocus={true}
          />
          <input
            onChange={(e) => {
              setPhoneNumber({
                ...phoneNumber,
                digit2: e.target.value,
              });
              nextInputSeries(2);
            }}
            value={phoneNumber.digit2}
            maxLength={1}
            name='digit2'
            type='text'
          />
          <input
            onChange={(e) => {
              setPhoneNumber({
                ...phoneNumber,
                digit3: e.target.value,
              });
              nextInputSeries(3);
            }}
            value={phoneNumber.digit3}
            maxLength={1}
            name='digit3'
            type='text'
          />
          <input
            onChange={(e) => {
              setPhoneNumber({
                ...phoneNumber,
                digit4: e.target.value,
              });
              nextInputSeries(4);
            }}
            value={phoneNumber.digit4}
            maxLength={1}
            name='digit4'
            type='text'
          />
          <input
            onChange={(e) => {
              setPhoneNumber({
                ...phoneNumber,
                digit5: e.target.value,
              });
              nextInputSeries(5);
            }}
            value={phoneNumber.digit5}
            maxLength={1}
            name='digit5'
            type='text'
          />
        </div>
        {isCodeValid === false && (
          <p style={{ marginTop: "-24px", textAlign: "center" }} className='stockHighlightMesggaes2'>
            Wrong code entered
          </p>
        )}
        <p className='InputSeriespwe'>Didn't you receive any code ?</p>
        <p onClick={resendOTP}>RESEND CODE</p>
        {loading && <Spinner position={"absolute"} />}
      </div>
    </>
  );
};
